const callbacks = {};

export function register(name, fn, priority) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (!callbacks[name]) {
		callbacks[name] = [];
	}
	fn._priority = priority ?? 10;
	callbacks[name].push(fn);
	callbacks[name].sort((a, b) => a._priority - b._priority);
}

export async function call(name, data, context) {
	// console.log(name, data);
	if (!callbacks[name]) {
		return data;
	}
	return callbacks[name].reduce(async (data, fn) => fn(await data, context), data);
}

export default { register, call };